import styled, { css } from "styled-components";
import { Modal } from "react-bootstrap";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 35px;
  padding: 25px 35px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  min-height: calc(100vh - 80px - calc(35px * 2));

  @media (max-width: 768px) {
    margin: 16px;
    padding: 24px 19px;
  }
`;

type ShowTourProps = {
  showTour?: boolean;
};

export const FiltersAndActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const BillsContentWrap = styled.div<ShowTourProps>`
  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
      width: 100%;
      background-color: #ffff;
      padding: 4px;
      border-radius: 8px;
    `}
`;

export const FilterWrap = styled.div<ShowTourProps>`
  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
      width: 420px;
      background-color: #ffff;
      padding: 4px;
      border-radius: 8px;
    `}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 17px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

export const HeaderInfos = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const HeaderTitle = styled.h1`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 24px;
  line-height: 37px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 33px;
  }
`;

export const HeaderSubtitle = styled.h2`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 16px;
  line-height: 24px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const ContentButtons = styled.div`
  display: flex;
  gap: 10px;

  & button {
    min-width: 120px;
  }

  @media (max-width: 768px) {
    gap: 5px;
    flex-wrap: wrap;

    & button {
      display: flex;
      min-width: fit-content;
      gap: 10px;

      & div {
        position: relative;
        margin: 0;
      }

      & svg {
        min-width: 18px;
      }

      & span {
        font-size: 12px;
      }
    }
  }
`;

export const BoxPaddingContainer = styled.div`
  position: relative;
`;

export const BoxPadding = styled.div<ShowTourProps>`
  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
    `}
`;

export const BoxFilters = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  max-width: 350px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  overflow: auto;
  height: 100%;
  width: 100%;
  margin-top: 34px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const Divider = styled.div`
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
`;

export const NotContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  span {
    color: ${({ theme }) => theme.colors.gray};
    font-size: 16px;
    line-height: 24px;

    span {
      font-family: "Mangueira Bold";
    }
  }
`;

export const StyledModal = styled(Modal)`
  .modal-dialog {
    @media (min-width: 640px) {
      max-width: 600px !important;
    }
  }
`;

export const PaginationWrapper = styled.div`
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  width: 100%;
`;
